import { TicketStatusesQueries } from '@/graphql/queries/ticketStatuses.queries'
import { TicketStatus } from '@/types/TicketStatus'

import { useGraphql } from '../useGraphql'

const useTicketStatuses = () => {
  const ticketStatusQuery = useGraphql<{ ticketStatuses: TicketStatus[] }>(
    TicketStatusesQueries.QUERY_KEY,
    TicketStatusesQueries.getTicketStatuses(),
    {},
  )
  return ticketStatusQuery
}

export default useTicketStatuses
